import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { setCheckoutBalance } from '@/redux/app/actions/organization';
import { orgBalanceOptionsSelector, orgCheckoutBalanceSelector } from '../../../redux/app/selectors/organization';

export const AddBalance = () => {
  const dispatch = useDispatch();
  const checkoutBalance = useSelector(orgCheckoutBalanceSelector);
  const createBalanceOptions = (el) => <option key={el} value={el}>{`$${el.toLocaleString()}.00`}</option>;
  const balances = useSelector(orgBalanceOptionsSelector);
  const balanceSelectOptions = balances.map(createBalanceOptions);
  const handleSelectChange = (e) => {
    dispatch(setCheckoutBalance(parseInt(e.currentTarget.value, 10)));
  };

  return (
    <div className="body pa-20 mb-20">
      <div className="flex justify-between">
        <div className="item-header">
          <p className="orange bold-900">Balance Amount</p>
        </div>
        <div className="select-wrapper checkout">
          <select
            value={checkoutBalance}
            onChange={handleSelectChange}
          >
            {balanceSelectOptions}
          </select>
        </div>
      </div>
    </div>
  );
};
